import {Component, OnInit} from '@angular/core';
import {Input} from '@angular/core';
import {Product} from '../../../../../models/product';
import {environment} from '../../../../../../../environments/environment';
import {ProductOptionsService} from '../../product-options/product-options.service';
import {NewShippingAddressComponent} from '../../../../checkout/checkout-shipping-address/new-shipping-address/new-shipping-address.component';
import {MatDialog} from '@angular/material/dialog';
import {ImageLightBoxComponent} from './image-light-box/image-light-box.component';

@Component({
    selector: 'app-main-image',
    templateUrl: './main-image.component.html',
    styleUrls: ['./main-image.component.css']
})
export class MainImageComponent implements OnInit {


    constructor(private productOptionService: ProductOptionsService , private dialog: MatDialog ) {
    }
    @Input() product: Product;
    displayStyle;
    elem: HTMLElement;
    posX ;
    posY ;
    rect;
    hover: any;

    ngOnInit(): void {
        this.elem = document.getElementById('myDiv');
        //  this.rect = this.elem.getBoundingClientRect();
        // this.posX = this.elem.offsetLeft;
        // this.posY = this.elem.offsetTop;

        this.productOptionService.optionItemSelectedEvent.subscribe( product => {

            this.product = product;
        });

        this.productOptionService.optionItemMouseOverEvent.subscribe( product => {

            this.product = product;
        });



    }

    openPopup() {
        this.displayStyle = 'block';
    }
    closePopup() {
        this.displayStyle = 'none';
    }

    getImageURL() {

        const image_url = this.product.getImage();
        return image_url;

    }

    openImageDialog(event , index) {
        event.preventDefault();
        const dialogRef = this.dialog.open(ImageLightBoxComponent, {
            data: {product : this.product , index : index },
            // width: '100%',
            // maxWidth: '100%',


        });

    }
    changePosition(event) {


        this.elem.style.backgroundPositionX = event.x + 'px' ;
        this.elem.style.backgroundPositionY = event.y + 'px' ;
        // elem.setAttribute('style', 'backgroundPositionX:' + event.offsetX + 'px' + '; backgroundPositionY:' + event.offsetY + 'px');
    }
    resetPositon() {
        this.elem.style.backgroundPositionX = 0 + 'px' ;
        this.elem.style.backgroundPositionY = 0 + 'px' ;

    }

}
